import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as NotificationTriggersActions from './notification-triggers.actions';
import {INotificationTrigger} from "@boma/supplier-portal/shared/entities";

export const NOTIFICATIONTRIGGERS_FEATURE_KEY = 'notificationTriggers';

export interface State extends EntityState<INotificationTrigger> {
  selectedId?: string | number; // which NotificationTriggers record has been selected
  loaded: boolean; // has the NotificationTriggers list been loaded
  error?: string | null; // last known error (if any)
}

export interface NotificationTriggersPartialState {
  readonly [NOTIFICATIONTRIGGERS_FEATURE_KEY]: State;
}

export const notificationTriggersAdapter: EntityAdapter<INotificationTrigger> = createEntityAdapter<
  INotificationTrigger
>();

export const notificationTriggersInitialState: State = notificationTriggersAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

export const notificationTriggersReducer = createReducer(
  notificationTriggersInitialState,
  on(NotificationTriggersActions.loadNotificationTriggers, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(
    NotificationTriggersActions.loadNotificationTriggersSuccess,
    (state, { notificationTriggers }) =>
      notificationTriggersAdapter.setAll(notificationTriggers, {
        ...state,
        loaded: true,
      })
  ),
  on(
    NotificationTriggersActions.loadNotificationTriggersFailure,
    (state, { error }) => ({ ...state, error })
  )
);
